import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const AuthenticatedRoute = ({ component: Component, isAuthenticated, loading, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (loading) {
        return null;
      }
      return isAuthenticated
        ? <Component {...props} />
        : <Redirect to="/oauth" />;
    }}
  />
);

export default AuthenticatedRoute;
